import React from 'react'
import { IconProps } from '../../../common/types'

const PlacementIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M20.5 11.988v-4.26c0-4.03-.94-5.04-4.72-5.04H8.22c-3.78 0-4.72 1.01-4.72 5.04v11.26c0 2.66 1.46 3.29 3.23 1.39l.01-.01c.82-.87 2.07-.8 2.78.15l1.01 1.35M8 7.688h8M9 11.688h6M14.671 18.998c-.14.14-.27.4-.3.59l-.19 1.35c-.07.49.27.83.76.76l1.35-.19c.19-.03.46-.16.59-.3l3.54-3.54c.61-.61.9-1.32 0-2.22-.89-.89-1.6-.6-2.21.01z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M17.7 15.968c.3 1.08 1.14 1.92 2.22 2.22"
      ></path>
    </svg>
  )
}

export default PlacementIcon
